import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tabs: {}
};

const tabStateSlice = createSlice({
  name: "tabState",
  initialState,
  reducers: {
    saveTabState: (state, action) => {
      const { tabId, data, tab, detailsTab, finTab, docketTab } = action.payload;
      state.tabs[tabId] = {...data, tab, detailsTab, finTab, docketTab }; 
    }
  },
});

export const { saveTabState } = tabStateSlice.actions;
export default tabStateSlice.reducer;
